import { useEffect, useState } from 'react'

/**
 * O cabecalho ganha fundo depois de 30px, e se esconde quando o visitante
 * desce — mas nunca com o menu aberto, senao o painel sumiria junto.
 * O botao flutuante do WhatsApp aparece depois de 600px.
 */
export function useHeaderScroll(menuAberto: boolean) {
  const [grudado, setGrudado] = useState(false)
  const [escondido, setEscondido] = useState(false)
  const [mostrarWhats, setMostrarWhats] = useState(false)

  useEffect(() => {
    let anterior = window.pageYOffset

    const aoRolar = () => {
      const y = window.pageYOffset
      setGrudado(y > 30)
      setEscondido(!menuAberto && y > anterior && y > 420)
      setMostrarWhats(y > 600)
      anterior = y
    }

    window.addEventListener('scroll', aoRolar, { passive: true })
    aoRolar()
    return () => window.removeEventListener('scroll', aoRolar)
  }, [menuAberto])

  return { grudado, escondido, mostrarWhats }
}
